import React, { StrictMode, useEffect } from 'react';
import * as ReactDOM from 'react-dom/client';
import { ChakraProvider, ColorModeScript } from '@chakra-ui/react';
import App from './App';
import theme from './Theme/theme.js';
import './i18n';
import { useTranslation } from 'react-i18next';

function RootWrapper() {
  const { i18n } = useTranslation();

  useEffect(() => {
    const lang = i18n.language === 'ar' ? 'ar' : 'en';
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
  }, [i18n.language]);

  return <App />;
}

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(
  <StrictMode>
    <ChakraProvider theme={theme}>
      <ColorModeScript initialColorMode={theme.config.initialColorMode} />
      <RootWrapper />
    </ChakraProvider>
  </StrictMode>
);
